import * as util from 'util';
import _ from 'lodash';
import {RouteService} from "../../services/routeService";
import {NotificationService} from "../../services/notificationService";
import {GeneralService} from "../../services/generalService";
import {AuthService} from "../../services/authService";
import {DICTIONARY} from "../../dictionary";
import {AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {ResolveEnd, Router} from "@angular/router";
import {Subject, takeUntil} from "rxjs";
import {LookAndFeelService} from "../../services/lookAndFeelService";
import {UserPermissionService} from "../../services/userPermissionService";
import {QuickAccessService} from "../../services/quickAccessService";


@Component({
	selector: 'content-component',
	templateUrl: './content.component.html',
})
export class ContentComponent implements OnInit, AfterViewInit, OnDestroy {
    constructor(private router:Router,
				private ngZone:NgZone,
				private authService:AuthService,
				private rs:RouteService,
				public gs:GeneralService,
				public userPermissionService:UserPermissionService,
				public lfs:LookAndFeelService,
				private ns:NotificationService,
				private quickAccessService: QuickAccessService) {
    }

    dic = DICTIONARY;
	_ = _;
	showAdminDropdown = false;
	canNavigateClientPrev = false;
	canNavigateClientNext = false;
    showComodo = this.gs.showComodo;
    appPagesNaviData = [];
    url = this.gs.url;
    about = this.gs.about;
    useCases = this.gs.useCases;
    eula = this.gs.eula;
    privacy = this.gs.privacy;
    antiSpam = this.gs.antiSpam;
    contactUs = this.gs.contactUs;
    footerCompanyName = this.gs.footerCompanyName;
    isSidebarCollapsed = (localStorage.isSidebarCollapsed === 'true');
	showOnboardingWizard = false;
    onboardingInfo;
    onboardingActiveStep;
    activeItemTitle;
    currentSection;
    currentPage;
    isMultiTenantSupported;
    searchResults;
    showGlobalSearchResults;
    searchText;
    showOnboardingButton;
    onboardingStatusTxt;
    onboardingInstallationDone;
	showPersonalPages;
	appLoaded;
	isTimeout;
	timeoutIdle;
	planAdmins = sortPlanAdmins(this.gs.planAdmins);

	sessionIdleLogout;

	userInfo;

	private unsubscribeAll: Subject<any> = new Subject<any>();

	@ViewChild('appContainer') appContainer: ElementRef;


    ngOnInit() {
		this.gs.getUserInfo(false,  (userInfo, err) => {
			this.userInfo = userInfo;
			this.setMultiTenantSupport();
			if (this.gs.reviewerInfo?.is_security_reviewer) {
				this.updateClientNavState();
			}
			this.appLoaded = true;
			this.gs.setDarkMode(this.userInfo.dark_mode);
			if (this.userInfo.plan?.customization?.lf?.enabled) {
				this.lfs.applyLf(this.userInfo.plan?.customization?.lf?.color || '', this.userInfo.plan?.customization?.lf?.logo ? "data:image/png;base64," + this.userInfo.plan.customization.lf.logo : '')
			}

			this.shouldShowPersonalPages(userInfo);
			this.resetTimer();
		});

		this.setNavigationData();

		this.updateNavigationState(this.router.url);


        this.gs.adminInfoMap = {};
        this.getOnboardingInfo();

		this.setEventSubscribers();
    }

	ngOnDestroy() {
		this.unsubscribeAll.next({});
	}

	ngAfterViewInit() {
		this.ngZone.runOutsideAngular(() => {
			// run outside Angular to avoid change detection every mouse move in all descendents
			this.appContainer.nativeElement.addEventListener('mousemove',this.resetTimer);
			this.appContainer.nativeElement.addEventListener('keypress',this.resetTimer);
		});
	}

	setEventSubscribers = () => {
		this.router.events.pipe(takeUntil(this.unsubscribeAll)).subscribe((routerData) => {
			if (routerData instanceof ResolveEnd){
				this.updateNavigationState(routerData.url);
			}
		});

		this.gs.primaryNameChangeSubj.pipe(takeUntil(this.unsubscribeAll)).subscribe((data) => {
			if (!data) {return;}

			this.gs.userInfo.firstName = data.firstName;
			this.gs.userInfo.lastName = data.lastName;
		});

		this.gs.navigatedThroughOnboardingSubj.pipe(takeUntil(this.unsubscribeAll)).subscribe((data) => {
			if (!data) {return;}

			this.onboardingActiveStep = data; // {scope: inbound/outbound, stepName: stepName}
			this.showOnboardingWizard = false;
		});

		this.gs.cancelOnboardingActiveStepSubj.pipe(takeUntil(this.unsubscribeAll)).subscribe((data) => {
			if (!data) {return;}

			this.onboardingActiveStep = null;
		});

		this.gs.cancelOnboardingActiveStepSubj.pipe(takeUntil(this.unsubscribeAll)).subscribe((data) => {
			if (!data) {return;}

			this.onboardingActiveStep = null;
		});

		this.gs.updatePlanAdminsSubj.pipe(takeUntil(this.unsubscribeAll)).subscribe((data) => {
			if (!data) {return;}

			setTimeout(() => { // wait for main subscriber in generalService to end his job
				this.planAdmins = sortPlanAdmins(this.gs.planAdmins);
				if (this.gs.reviewerInfo?.is_security_reviewer) {
					this.updateClientNavState();
				}
			}, 100);

			if (data.init) {
				const urlTree = this.router.parseUrl(this.router.url);
				const controlAdminEmail = urlTree.queryParams['controlAdmin'];
				if (controlAdminEmail) {
					const matchingAdmin = this.gs.planAdmins?.find(a => a.email === controlAdminEmail);
					if (matchingAdmin) {
						this.gs.controlAdmin = matchingAdmin;
						this.authService.setManagedAdmin(matchingAdmin.email);
						if (matchingAdmin.email !== this.gs.userInfo?.email) {
							this.rs.getCustomization().then(plan => {
								if (this.gs.adminInfoMap[matchingAdmin.email]) {
									this.gs.adminInfoMap[matchingAdmin.email].plan.customization.lf = plan.customization.lf;
								}
								this.applyLF(plan.customization.lf);
								this.authService.setManagedAdmin(this.gs.controlAdmin.email);
								const newActiveRoutePath = this.router.serializeUrl(urlTree);
								this.router.navigateByUrl('/dummy', { skipLocationChange: true }).then(() => {
									this.router.navigateByUrl(newActiveRoutePath).then(() => {
										this.ns.showWarnMessage(util.format(this.dic.MESSAGES.controlAdminChanged, this.gs.controlAdmin.display_email));
									});
								});
							});
						}
					}
				}
			}
		});
	}

	resetTimer = () => {
		this.authService.isAuthenticated().then(isAuthenticated => {
			if (!isAuthenticated || this.isTimeout) {
				return;
			}
			clearTimeout(this.timeoutIdle);
			const sessionTimeoutMinutes = this.userInfo.plan.wa_idle_session_timeout || 3 * 60; // 3 hours default
			this.timeoutIdle = setTimeout(() => {
				// back to Angular
				this.ngZone.run(() => {
					this.authService.appTimeoutSubj.next(true);
					this.isTimeout = true;
				});
			}, sessionTimeoutMinutes * 60 * 1000);
		});
	}

	setNavigationData = () => {
		this.appPagesNaviData = [];
		const setRouteData = (routeObj, level, fullPath) => { // level: 0-section. 1-page. 2-tab.

			// pick navigation data fields + 'state'/'page'/'tab' field
			const edittedRoute = _.pick(routeObj.data || {}, ['title', 'tag', 'iconClass', 'isNewFeature', 'isBetaFeature', 'iconSvgName', 'showInSidebar', 'keywords']);
			edittedRoute['tag'] = level === 0 ? (edittedRoute.tag || edittedRoute.title) : null;
			const pathName =  ['state', 'page', 'tab'][level];
			edittedRoute[pathName] = routeObj.path;
			fullPath += '/' + routeObj.path;

			edittedRoute['show'] = this.userPermissionService.getPermission(_.trim(fullPath, '/')) === true;

			Object.assign(routeObj, edittedRoute);

			// set 'pages'/innerTabs' fields
			if (routeObj.children) {
				const childrenName = level === 0 ? 'pages' : 'innerTabs';
				routeObj[childrenName] = _.cloneDeep(_.filter(routeObj.children, 'path'));
				routeObj[childrenName].forEach(childRoute => {
					setRouteData(childRoute, level + 1, fullPath);
				});
			}

			// Delete redundunt fields
			const keysToDelete = ['path', 'component', 'children', 'data'];
			keysToDelete.forEach(key => delete routeObj[key]);

			if (level === 0) {
				this.appPagesNaviData.push(routeObj);
			}
		}

		////

		const contentRoute:any = _.cloneDeep(_.find(this.router.config, route => !route.path && route.children));
		contentRoute.children.forEach(route => {
			if (route.path && route.path !== 'dummy') {
				setRouteData(route, 0, '');
			}
		});

		this.setLinksForGlobalSearch();
	}

	setLinksForGlobalSearch = () => {
		const linksForSearch = [
			{
				title: 'Authentication',
				url: 'https://docs.trustifi.com/docs/authentication',
				show: true,
				showInSidebar: false,
				keywords: ['Authentication']
			},
			{
				title: 'Sensitivity Threshold',
				url: 'https://docs.trustifi.com/docs/sensitivity-threshold',
				show: true,
				showInSidebar: false,
				keywords: ['Sensitivity Threshold']
			}
		];

		this.appPagesNaviData = this.appPagesNaviData.concat(linksForSearch);
		this.quickAccessService.appPagesNaviData = this.appPagesNaviData;
	}

    logout() {
        this.authService.logout();
    };

    toggleSidebarWidth() {
        this.activeItemTitle = null;
        this.isSidebarCollapsed = !this.isSidebarCollapsed;
        localStorage.isSidebarCollapsed = this.isSidebarCollapsed.toString();
    }

	setMultiTenantSupport = () => {
		this.isMultiTenantSupported = this.gs.isSectionMultiTenantSupported(this.currentSection);
	};

	// CC: taken from inbound-quarantined.component.ts -> canNavigateThreatPrev/Next + navigateThreatAnalysisEmail (no keyboard)
	updateClientNavState = () => {
		const canShow = this.gs.reviewerInfo?.is_security_reviewer
			&& this.planAdmins?.length > 1
			&& this.userInfo?.show_multi_tenant
			&& this.isMultiTenantSupported;
		if (!canShow) {
			this.canNavigateClientPrev = false;
			this.canNavigateClientNext = false;
			return;
		}
		const idx = _.findIndex(this.planAdmins, a => a.email === this.gs.controlAdmin?.email);
		this.canNavigateClientPrev = idx > 0;
		this.canNavigateClientNext = idx > -1 && idx < this.planAdmins.length - 1;
	};

	navigateClient = (direction, event) => {
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}
		if (!this.gs.reviewerInfo?.is_security_reviewer) {
			return;
		}
		const idx = _.findIndex(this.planAdmins, a => a.email === this.gs.controlAdmin?.email);
		const target = this.planAdmins[idx + direction];
		if (!target) {
			return;
		}
		this.changeControlAdmin(target);
	};

    updateNavigationState(fullStateString) {
        const statesHierarchyArr = fullStateString.substring(1).split('/');


		this.currentSection = statesHierarchyArr[0].split('?')[0];
        this.currentPage = (statesHierarchyArr[1] || '').split('?')[0]  || '';

		this.setMultiTenantSupport();
		if (this.gs.reviewerInfo?.is_security_reviewer) {
			this.updateClientNavState();
		}

        if (!statesHierarchyArr[2]) { // close all notifications when navigating to a new section or page, but not when navigating to a new tab
            this.ns.closeAll();
        }

        if (this.appPagesNaviData.length) {
            const currentPageObj = this.getTitleAndIcon(this.currentSection);
            if (currentPageObj) {
                this.activeItemTitle = currentPageObj.title;
            }
        }
    }

    getTitleAndIcon(stateName) {
        // state's title & icon:
        let targetPage;
        targetPage = _.find(this.appPagesNaviData, pageDataObj => {
            // search in page
            if (pageDataObj.state && pageDataObj.state === stateName) {
                return true;
            }
            // search in sub-pages
            else if (pageDataObj.pages) {
                const isSubPage = _.find(pageDataObj.pages, subPageDataObj => {
                    if (subPageDataObj.state && subPageDataObj.state === stateName) {
                        return true;
                    }
                });
                if (isSubPage) {
                    return true; // return the parent
                }
            }
        });

        if (targetPage) {
            return {title: targetPage.title, icon: targetPage.iconClass, iconSvgName: targetPage.iconSvgName};
        }
    }

    searchGlobal(searchText) {
        this.searchResults = [];
        if (!searchText || searchText.length < 2) {
            this.showGlobalSearchResults = false;
            return;
        }
        this.showGlobalSearchResults = true;
        searchText = searchText.toLowerCase();
        // clone the pages data object first, because some changes to items are applied before releasing results
        const appPagesNaviDataCopy = _.cloneDeep(this.appPagesNaviData);

        // search syntax function:
        // Reminder. Hirarchy: Section ----> page -----> tab
        const searchInSinglePageObj = (contentObj, parentSection, parentPage) => {
            if (contentObj.show) {
                contentObj['parentSection'] = parentSection || null; // used for showing the parent section 'tag' in search results box, and for using the parent 'state' property when navigating
                contentObj['parentPage'] = parentPage || null; // used for showing the parent page 'title' in search results box, and for using the parent 'page' property when navigating

                if (contentObj.keywords) {
                    // flatten the keywords array of string to one long string and keep the place the search string is found in it for results rating
                    let flattenKeywords = contentObj.keywords.join(" ");
                    flattenKeywords = flattenKeywords.toLowerCase();
                    const foundInStringIdx = flattenKeywords.indexOf(searchText);
                    // regex check if the search input is found in the start of a word
                    const isStartOfWord = (new RegExp('\\b' + searchText, 'i')).test(flattenKeywords);

                    // page approved to results:
                    if (foundInStringIdx > -1 && isStartOfWord) {
                        contentObj['rate'] = foundInStringIdx; // used for sorting the results by relevance
                        this.searchResults.push(contentObj);
                    }
                }

                // recursion to search in sub-pages (second level) or inner tabs (third level)
                const pageChildren = contentObj.pages || contentObj.innerTabs;
                if (pageChildren) {
                    pageChildren.forEach(childPageObj => {
                        searchInSinglePageObj(childPageObj, parentSection || contentObj, contentObj.innerTabs && contentObj)
                    });
                }
            }
        }

        // perform search syntax for each page
        appPagesNaviDataCopy.forEach(pageObj => {
            searchInSinglePageObj(pageObj, null, null);
        });
    }

    navigateFromSearch(resultPageObj) {
        // result redirect to external link
        if (resultPageObj.url) {
            return;
        }
        // result redirect to a section
        if (!resultPageObj.page && !resultPageObj.tab) {
            this.navigateToPage(resultPageObj.state);
        }
        // result redirect to a page
        else if (resultPageObj.page) {
            this.navigateToPage(resultPageObj.parentSection.state, resultPageObj.page);
        }
        // result redirect to a page's inner tab
        else if (resultPageObj.tab) {
            this.navigateToPage(resultPageObj.parentSection.state, resultPageObj.parentPage.page, resultPageObj.tab);
        }

        this.searchText = '';
        this.showGlobalSearchResults = false;
    }

    navigateToPage(state, page=null, tab=null) {
		const adminPages = [this.dic.CONSTANTS.appStates.adminOutbound,
			this.dic.CONSTANTS.appStates.adminInbound, this.dic.CONSTANTS.appStates.threatSimulation
			, this.dic.CONSTANTS.appStates.domainProtection, this.dic.CONSTANTS.appStates.accountCompromised
			, this.dic.CONSTANTS.appStates.collaborationProtection, this.dic.CONSTANTS.appStates.archive
		];
		if (adminPages.includes(state)) {
			const urlTree = this.router.parseUrl(this.router.url);
			const controlAdminEmail = urlTree.queryParams['controlAdmin'];
			const queryParams = controlAdminEmail ? {controlAdmin: controlAdminEmail} : {};
			this.router.navigate(_.compact([state, page, tab]), {queryParams});
		}
		else {
			this.router.navigate(_.compact([state,page,tab]));
		}

        if (page) {
            this.currentPage = page;
        }

		if (window.matchMedia('(max-width: 991px)').matches) {
			setTimeout(() => {
				this.toggleSidebarWidth();
			});
		}
	};

    changeControlAdmin(admin) {
        if (this.gs.controlAdmin && this.gs.controlAdmin.email === admin.email) {
            return;
        }
        this.gs.controlAdmin = admin;
        this.authService.setManagedAdmin(this.gs.controlAdmin.email);
		// CC: technician (managed plans only) - the sidebar depends on the selected tenant (own plan: User Management + Partner only)
		if (this.gs.userInfo?.managed_plans_only) {
			this.setNavigationData();
		}
		if (this.gs.reviewerInfo?.is_security_reviewer) {
			this.updateClientNavState();
		}

		const urlTree = this.gs.setControlAdminURI(admin);

		// reload views and controllers for new admin (reloads the last level of state)
		// we route to a dummy here (we don't want to fall into the content route adminGuard guard again)
		const newActiveRoutePath = this.router.serializeUrl(urlTree);
		this.router.navigateByUrl('/dummy', { skipLocationChange: true }).then(() => {
			this.router.navigateByUrl(newActiveRoutePath).then(() => {
				this.ns.showWarnMessage(util.format(this.dic.MESSAGES.controlAdminChanged, this.gs.controlAdmin.display_email));
			});
		});

		if (this.gs.controlAdmin.email !== this.gs.userInfo.email) {
			if (this.gs.adminInfoMap[this.gs.controlAdmin.email]?.lf) {
				this.applyLF(this.gs.adminInfoMap[this.gs.controlAdmin.email].lf);
			}
			else {
				this.rs.getCustomization().then(plan => {
					if (this.gs.adminInfoMap[this.gs.controlAdmin.email]) {
						this.gs.adminInfoMap[this.gs.controlAdmin.email].plan.customization.lf = plan.customization.lf;
					}
					this.applyLF(plan.customization.lf);
				});
			}
		}
		else {
			this.applyLF(this.gs.userInfo.plan.customization.lf);
		}
    };

	applyLF = (lfData) => {
		if (lfData.enabled) {
			this.lfs.applyLf(lfData.color, lfData.logo ? "data:image/png;base64," + lfData.logo : '');
		}
		else {
			this.lfs.resetLfToDefault();
		}
	}

    getOnboardingInfo() {
        if (!this.userInfo || this.userInfo.type === this.dic.CONSTANTS.userTypes.heroku
            || (this.userInfo.user_role === this.dic.CONSTANTS.userRole.user && this.userInfo.plan.plan === this.dic.CONSTANTS.planTypePro)) {
            return;
        }

        this.rs.getOnboardingProcessInfo().then((response) => {
            this.setBoardingInfo(response.onboarding_process);
        }, (err) => {
        });
    }

    setBoardingInfo(onboardingProcessObj) {
        this.onboardingInfo = onboardingProcessObj;
        this.showOnboardingButton = true;

        this.onboardingStatusTxt = '';
        switch (this.onboardingInfo?.questionnaire_step) {
            case this.dic.CONSTANTS.onboardingProcessQuestionnaireStep.init:
                this.onboardingStatusTxt = "Install Trustifi easily";
                break;

            case this.dic.CONSTANTS.onboardingProcessQuestionnaireStep.pendingSupport:
                this.onboardingStatusTxt = "Pending review";
                break;

            case this.dic.CONSTANTS.onboardingProcessQuestionnaireStep.completed:
                // BC for users who do not have questionnaire at all
                if (!this.onboardingInfo.questionnaire) {
                    this.showOnboardingButton = false;
                    return;
                }

                this.onboardingStatusTxt = "Review installation";
                // check if all steps are done
                if (this.onboardingInfo.outbound_steps && this.onboardingInfo.outbound_steps.length && this.onboardingInfo.outbound_steps.find(step => step.status !== this.dic.CONSTANTS.onboardingStepStatus.done)) {
                    this.onboardingStatusTxt = 'Continue Installation';
                }
                else if (this.onboardingInfo.inbound_steps && this.onboardingInfo.inbound_steps.length && this.onboardingInfo.inbound_steps.find(step => step.status !== this.dic.CONSTANTS.onboardingStepStatus.done)) {
                    this.onboardingStatusTxt = 'Continue Installation';
                }
                else {
                    this.onboardingInstallationDone = true;
                }
                break;

            default:
                this.onboardingStatusTxt = 'Review Installation';
        }
    }

	shouldShowPersonalPages(userInfo) {
		if (userInfo?.type === this.dic.CONSTANTS.userTypes.dlp) {
			this.showPersonalPages = false;
			this.gs.showSupportMenu = false;
			return;
		}

		if (!userInfo?.plan.allow_support_wa || (
			userInfo.plan.restrict_support_to_admins_and_reviewers && !isUserReviewer(userInfo) && userInfo?.user_role === this.dic.CONSTANTS.userRole.user)) {
			this.gs.showSupportMenu = false;
		}
		else {
			this.gs.showSupportMenu = true;
		}

		const hidePersonalPagesPlans = ["650cc08cd74b1462095f319b"]; // bkash :(

		if (hidePersonalPagesPlans.includes(userInfo.plan._id)) {
			if (userInfo?.user_role === this.dic.CONSTANTS.userRole.admin || userInfo?.user_role === this.dic.CONSTANTS.userRole.subAdmin) {
				this.showPersonalPages = true;
				return;
			}

			this.showPersonalPages = false;
			return;
		}

		this.showPersonalPages = true;
	}

	darkModeToggle = () => {
		this.userInfo.dark_mode = !this.userInfo.dark_mode;
		this.gs.setDarkMode(this.userInfo.dark_mode);

		const actionInfo = {
			action: this.dic.CONSTANTS.userProfileActions.darkmode,
			enabled: this.userInfo.dark_mode
		};
		this.rs.updateUserSettings(actionInfo).then(() => {});
	}

    protected readonly window = window;
}

function isUserReviewer(userInfo) {
	return userInfo.isAccountCompromisedReviewer || userInfo.isArchiveReviewer || userInfo.isInboundReviewer
		|| userInfo.isOutboundReviewer || userInfo.isPartnerReviewer || userInfo.isThreatSimulationReviewer
		|| userInfo.isCollaborationProtectionReviewer;
}

function sortPlanAdmins(planAdmins) {
	return _.orderBy(planAdmins, [
		admin=> _.isEqual(admin, planAdmins[0]), // primary sort priority: main admin stays first in list
		admin=> admin.display_email.toLowerCase() // secondary sort priority: by email (alphabetically)
	],['desc', 'asc']);
}
